import { type FC } from "react";

import { AutoSizer, VirtualTable } from "@snapchat/snap-design-system";

import { useGetTrendingTags } from "../hooks/useGetTrendingTags";

import { TrendingTagsListContainer, rowClassname } from "./TrendingTagsList.styles";
import { getColumns } from "./TrendingTagsListColumns";

interface TrendingTagListProps {
    onRowClick?: (tag: string) => void;
}

export const TrendingTagsList: FC<TrendingTagListProps> = ({ onRowClick }) => {
    const { data, loading } = useGetTrendingTags();
    const handleRowClick = (_: React.MouseEvent, row: number) => {
        onRowClick && onRowClick(data[row]?.tag ?? "");
    };

    return (
        <TrendingTagsListContainer>
            <AutoSizer>
                {({ height, width }) => (
                    <VirtualTable
                        data={data}
                        columns={getColumns()}
                        width={width}
                        height={height}
                        isLoading={loading}
                        hasMore={false}
                        rowHeight={60}
                        onRowClick={handleRowClick}
                        emptyMessage={"No tags found."}
                        rowClassName={rowClassname}
                        loadMore={() => new Promise(() => null)}
                    />
                )}
            </AutoSizer>
        </TrendingTagsListContainer>
    );
};
